import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { kBiMaxDatasetDescription } from '@euler/model/bi/upload';
import { memo } from 'react';
import { TextInput, View } from 'react-native';

/** The one sentence about the data, editable. */
export const DescriptionField = memo(
  ({
    value,
    disabled,
    onChange,
  }: {
    value: string;
    disabled: boolean;
    onChange: (value: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(4) }}>
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          数据说明
        </Typography.Text>
        <TextInput
          accessibilityLabel="数据说明"
          value={value}
          onChangeText={onChange}
          editable={!disabled}
          multiline
          maxLength={kBiMaxDatasetDescription}
          placeholder="一句话说明这份数据"
          placeholderTextColor={aiColors.mutedForeground}
          style={{
            minHeight: rpx(56),
            paddingHorizontal: rpx(12),
            paddingVertical: rpx(8),
            borderRadius: rpx(10),
            borderWidth: 1,
            borderColor: aiColors.border,
            backgroundColor: aiColors.input,
            color: aiColors.foreground,
            fontSize: rpx(13),
            lineHeight: rpx(19),
            textAlignVertical: 'top',
          }}
        />
      </View>
    );
  },
);
